export const IbanTraditionalCeremonies = [
  { 
    img_src: "https://66.media.tumblr.com/b5604d98ad7881835e40769b3b7faff8/61c6f81aebb1231f-58/s250x400/d43079e4d82d5a0e07fa4545b799fffa945b8d93.png",
    name: "Gawai Antu",
    alt: "Gawai-Antu",
    description: "Gawai Antu is a ceremony held to mark the end of a mourning period.",
    
  },
  
  { 
    img_src: "https://66.media.tumblr.com/b78f4f700c87dbbe2131408bf7767b18/61c6f81aebb1231f-9b/s250x400/0256039aaf7d4d88234295a188ea8a09b8e88103.png",
    name: "Gawai Lelabi",
    alt: "Gawai-Lelabi",
    description: "Gawai Lelabi si a wedding ceremony. It is where the family informs the public that their daughter is wed.",
    
  },
  
  { 
    img_src: "https://66.media.tumblr.com/aef85db140096a84ca4fe3eec4eb9a77/61c6f81aebb1231f-fc/s540x810/db982f704909056c89c5eda133417d229e0cea6c.png",
    name: "Mangkung Tiang",
    alt: "Mangkung-Tiang",
    description: "Mangkung Tiang literally translates as 'hitting the wall'. During the Mangkung Tiang ceremony, the main pole of a new house is hit with an intention of asking God's blessing.",
  },
  
  { 
    img_src:"https://66.media.tumblr.com/f5e70af45f7948c5fa513c2d411283cb/f0540ac695aea946-aa/s540x810/78dde064f8cbebf0fbdf6c99bab084c1e5bc3d9a.png",
    name: "Upacara Miring",
    alt:"Upacara-Miring",
    description: "The Miring ritual is usually performed to honour the 'petara' or gods, spirits, and ancestors. The ritual is performed to ask for protection and pray for success.",
  },
  
  {
    img_src: "https://66.media.tumblr.com/43750f1a670a62da58a158d29b50398e/61c6f81aebb1231f-5f/s540x810/a90e9ea130feed2669a257cddf06fe6c5e959016.png",
    name: "Ngiling Bidai",
    alt:"Ngiling-Bidai",
    description:"The Ngiling Bidai marks the end of Gawai Dayak celebration. It is a closing ceremony in which the mats used during the last day of celebration are being rolled up. Along with the Ngiling Bidai, the Ranyai ceremony is also performed. The Ranyai is where food and drinks are hung on banana tress and for those who wishes to participate in the ceremony, will perform a dance surround the tree carrying a machete to cut off those suspended food.",
  },
  
  {
    img_src:"https://66.media.tumblr.com/8f26056206869fc7de92eb33d735ba4b/61c6f81aebb1231f-90/s540x810/9288a712a32e8a0950e31b31bfd738a777f8a51b.png",
    name: "Gawai Ubung",
    alt:"Gawai-Ubung",
    description:"Gawai Ubung is a ceremony for women that provides weaving yarn.",
  },
  
  {
    img_src:"https://66.media.tumblr.com/ceeb9fdaebef0e7cc2737fe4c95846fc/61c6f81aebb1231f-1c/s540x810/f34c04a4a7a5e098a1f87fb097b47648fce16962.png",
    name: "Gawai Tuah",
    alt:"Gawai-Tuah",
    description:"Gawai Tuah is held as a thanksgiving ceremony.",
    
  },
  
  {
    img_src:"https://66.media.tumblr.com/ac8f12f260ceab547ea6d20ee70cf086/61c6f81aebb1231f-e2/s540x810/c8da2ba8b6efba4fd132f7e80f1c6c38659818fe.png",
    name: "Gawai Kelingkang",
    alt:"Gawai-Kelingkang",
    description:"Gawai Kelingkang is held if someone has chosen from god as a hero.",
  },
  
  {
    img_src:"https://66.media.tumblr.com/9fe31bf9ed33dbca1ed30cca84d48095/61c6f81aebb1231f-91/s540x810/06187fefe5efe1472d0477ea42f8e5f9f9e930b1.png",
    name: "Gawai Burung",
    alt:"Gawai-Burung",
    description:"Gawai Burung or Gawai Kenyalang is held in honour of Singong Burong, the god of war. The origin of this festival was associated with the belief of Aki Lang Sengalang Burong Jagu Menaul Tuntung (eagles) assigned by the barracks to lead all war work for the Iban community because he had all kinds of influences. Thus, Gawai Kenyalang can be held during or before expedition expires. It may also be held when an Iban warrior recieves an address from the dungeon through a dream to hold it. However, Gawai Kenyalang can only be held once an Iban comes back from walk after earning lucrative income or valuable items.",
  },
  {
    img_src:"https://66.media.tumblr.com/f413c72208268755385d4eaae7eed5da/61c6f81aebb1231f-0e/s540x810/a25443c84366906df9308580d090a64c723168ea.png",
    name: "Gawai Batu",
    alt:"Gawai-Batu",
    description:"Gawai Batu is the beginning of the paddy growing season. It is held to sharpen metal utensils such as machetes and axes.",
  },
  {
    img_src:"https://66.media.tumblr.com/08bb3b58225968e2122161f7c0260ce9/61c6f81aebb1231f-2a/s540x810/15b71682c38bfbc11f58dd4bd3d3e2873c85733b.png",
    name: "Gawai Tajau",
    alt:"Gawai-Tajau",
    description:"Gawai Tajau is for celebrating the acquisition of jams. Nowadays, Gawai Tajau is rarely done making the ceremony almost foreign to younger generations.",
  },
  
  ];